export class RoutePaths {
  public static readonly Home = '/'
  public static readonly Details = '/equipment/details/'
  public static readonly Search = '/equipment/'
  public static readonly LegacySearch = 'equipment/search'
  public static readonly Maintenance = '/maintenance'
  public static readonly Admin = '/admin'
}
